/* eslint-disable react/prop-types */
import React from "react";
import { StaticQuery, graphql } from "gatsby";
import { sortByKey } from "../../../../../utils";
import MediaImg from "../../../../../components/media-img";
import {
  container,
  contactCard,
  dept,
  details,
  fullName,
  brand,
  profileImage,
  position,
  staff_grid,
  actions
} from "./styles.module.scss";

export default function StaffDirectory({ custom_data }) {
  const StaffMember = (props) => {
    const { brands = "", first_name, last_name, title, image, email, phone, linkedin_url } = props;

    return (
      <div className={contactCard}>
        <div className={profileImage}>
          {image ? (
            <MediaImg
              media={{ data: true, ...image?.data[0].attributes }}
              alt={`${first_name} ${last_name}`}
            />
          ) : (
            <img src="/images/headshot-placeholder.jpg" alt="placeholder" />
          )}
        </div>
        <div className={details}>
          {brands && <span className={brand}>{brands}</span>}
          <span className={fullName}>{`${first_name} ${last_name}`}</span>
          {title && <span className={position}>{title}</span>}
          {(phone || email || linkedin_url) && (
            <div className={actions}>
              {phone && (
                <a href={`tel:${phone}`}>
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>{phone}</title>
                    <g fill="none" fillRule="evenodd">
                      <path
                        d="M4.482 0c-.321 0-.638.115-.902.327l-.038.019-.02.019-1.918 1.979.02.019a1.928 1.928 0 0 0-.519 2.075c.002.005-.002.014 0 .019.52 1.491 1.852 4.37 4.452 6.974 2.61 2.612 5.524 3.892 6.966 4.457h.02c.745.25 1.553.072 2.13-.423l1.937-1.94c.509-.51.509-1.393 0-1.902l-2.494-2.498-.02-.038c-.508-.51-1.41-.51-1.918 0l-1.229 1.23a9.933 9.933 0 0 1-2.513-1.73C7.43 7.627 6.917 6.522 6.728 6.09l1.228-1.23c.515-.516.525-1.376-.02-1.882l.02-.02-.058-.057L5.442.365l-.02-.02-.038-.018A1.446 1.446 0 0 0 4.482 0zm0 1.23c.046 0 .092.021.135.057l2.456 2.517.058.057c-.005-.004.036.06-.039.135L5.557 5.533l-.288.269.135.384s.705 1.89 2.187 3.304l.134.116c1.428 1.304 3.11 2.017 3.11 2.017l.383.173 1.823-1.825c.106-.106.086-.106.192 0l2.514 2.516c.105.106.105.068 0 .173l-1.88 1.883c-.284.242-.584.293-.941.173-1.391-.548-4.095-1.736-6.505-4.15-2.43-2.432-3.7-5.192-4.165-6.532-.093-.25-.026-.62.192-.807l.039-.038 1.861-1.902a.215.215 0 0 1 .134-.057z"
                        fill="currentColor"
                      />
                    </g>
                  </svg>
                </a>
              )}

              {email && (
                <a href={`mailto:${email}`}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>{email}</title>
                    <g fill="none" fillRule="evenodd">
                      <path
                        d="M16 2v11.79H0V2h16zm-1.348 4.246L8.006 9.661 1.347 6.339v6.103h13.306l-.001-6.196zm0-2.899H1.348v1.486l6.65 3.318 6.655-3.42V3.347z"
                        fill="currentColor"
                      />
                    </g>
                  </svg>
                </a>
              )}

              {linkedin_url && (
                <a href={linkedin_url} target="_blank" rel="noopener noreferrer">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>{linkedin_url}</title>
                    <path
                      d="M17.159 16.36h-2.843v-4.456c0-1.062-.02-2.429-1.48-2.429-1.478 0-1.704 1.159-1.704 2.353v4.533h-2.84V7.198h2.724V8.45h.04c.38-.72 1.307-1.48 2.69-1.48 2.881 0 3.413 1.897 3.413 4.365v5.026zM5.084 5.948a1.65 1.65 0 1 1 0-3.302 1.65 1.65 0 0 1 0 3.302zM3.66 16.36h2.848V7.198H3.659v9.163zM18.575 0H2.233C1.453 0 .819.62.819 1.385v16.43c0 .764.634 1.385 1.414 1.385h16.342c.782 0 1.419-.62 1.419-1.386V1.384C19.994.62 19.357 0 18.574 0z"
                      fill="currentColor"
                      fillRule="evenodd"
                    />
                  </svg>
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  const groupByDepartment = (data) => {
    const groupedData = {};
    data.forEach((item) => {
      const departmentTitle = item.attributes?.department?.data?.attributes?.title || "Other";

      if (!groupedData[departmentTitle]) {
        groupedData[departmentTitle] = [];
      }
      groupedData[departmentTitle].push(item);
    });

    Object.keys(groupedData).forEach((key) => {
      groupedData[key] = sortByKey(
        groupedData[key].map(({ attributes }) => attributes),
        "last_name"
      );
    });

    let orderedKeys = Object.keys(groupedData).sort();
    const orderedObj = {};

    if (custom_data?.order) {
      const remainingKeys = Object.keys(groupedData).filter(
        (key) => !custom_data.order.includes(key)
      );
      orderedKeys = [...custom_data.order, ...remainingKeys];
    }

    orderedKeys.forEach((key) => {
      orderedObj[key] = groupedData[key];
    });
    return orderedObj;
  };

  const renderDept = (staff = [], deptKey) => {
    const department = staff[0]?.department?.data?.attributes || {};
    const { title, description } = department;

    return (
      <section key={deptKey}>
        <header className={dept}>
          {(title || deptKey) && <h2>{title || deptKey}</h2>}
          {description && <p>{description}</p>}
        </header>
        <div className={staff_grid}>
          {staff.map((staffMember) => (
            <StaffMember key={staffMember.id} className={staffMember} {...staffMember} />
          ))}
        </div>
      </section>
    );
  };

  return (
    <div className={container}>
      <div className={`container`}>
        <StaticQuery
          query={graphql`
            query StaffQuery {
              cms {
                staffMembers(sort: "id", pagination: { limit: 1000 }) {
                  data {
                    id
                    attributes {
                      first_name
                      email
                      brands
                      image {
                        data {
                          attributes {
                            ...MediaAttributes
                          }
                        }
                      }
                      last_name
                      linkedin_url
                      phone
                      title
                      department {
                        data {
                          attributes {
                            title
                            description
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `}
          render={(data) => {
            const depts = groupByDepartment(data.cms.staffMembers?.data);
            return (
              <div>
                {Object.entries(depts).map(([deptKey, staff]) => renderDept(staff, deptKey))}
              </div>
            );
          }}
        />
      </div>
    </div>
  );
}
